module.exports = "https://static.wanderu.com/static/media/wanderu-logo.e19fc775.svg";